import Vue from "vue";

Vue.filter("clickable", function(item)
{
    function isNull(object)
    {
        return object === null;
    }
    function isUndefined(object)
    {
        // eslint-disable-next-line
        return typeof object === typeof void 0;
    }
    function isNullOrUndefined(object)
    {
        return isNull(object) || isUndefined(object);
    }

    let returnLink = null;

    if (item.hasOwnProperty("variationProperties"))
    {
        for (let i0 = 0; i0 < item.variationProperties.length; i0++)
        {
            if (item.variationProperties[i0].hasOwnProperty("properties"))
            {
                for (let i=0; i < item.variationProperties[i0].properties.length; i++)
                {
                    if (item.variationProperties[i0].properties[i].id === 18)
                    {
                        returnLink = "/"+item.variationProperties[i0].properties[i].values.value+"?variationId="+item.variation.id;
                    }
                }
            }
            else if (item.variationProperties[i0].property.groupId === 7 && item.variationProperties[i0].property.id === 18)
            {
                returnLink = "/"+item.variationProperties[i0].values.value+"?variationId="+item.variation.id;
            }
        }
    }

    const enableOldUrlPattern = App.config.global.enableOldUrlPattern;
    const urlPath = item.texts.urlPath || "";
    const includeLanguage = !isNullOrUndefined(item.texts.lang) && App.defaultLanguage != item.texts.lang;

    let link = "";

    if (urlPath.charAt(0) !== "/")
    {
        link = "/";
    }

    if (includeLanguage)
    {
        link += item.texts.lang + "/";
    }

    if (urlPath && urlPath.length)
    {
        link += urlPath;
    }

    let suffix = "";

    if (enableOldUrlPattern)
    {
        suffix = "/a-" + item.item.id;
    }
    else
    {
        suffix = "_" + item.item.id + "_" + item.variation.id;
    }

    let trailingSlash = "";

    if (App.urlTrailingSlash)
    {
        trailingSlash = "/";
        if (link.length > 1 && link.charAt(link.length - 1) === "/")
        {
            link = link.substr(0, link.length - 1);
        }
    }

    if (link.substr(link.length - suffix.length, suffix.length) === suffix)
    {
        return link + trailingSlash;
    }

    if (returnLink===null)
    {
        return link + suffix + trailingSlash;
    }
    else
    {
        return returnLink;
    }


});
